<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
    <div class="form-group form-row mx-1">
      <label mat-raised-button [matTooltip]="infoBulle" matTooltipClass="tooltip-large" [matTooltipPosition]="positionIB" [for]="idHtml">{{libelle$ | async }}
          <i *ngIf="infoBulle !== ''"  class="material-icons md-dark md-18"
          aria-hidden="true">
          info
         </i>
      </label>
      <div class="input-group">
        <input [readOnly]="afficherEnLectureSeule" (blur)="onBlur()" (keyup)="scroll(target)" [placeholder]="placeholder" bisKeypadNavigation type="text"
          [maxlength]="longueurMax" [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()"
          [class.is-valid]="champValide()" [formControlName]="label" class="form-control" [id]="idHtml">
      </div>
      <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors">
      </bis-affiche-erreurs>
      <div #target></div>
    </div>
  </form>